// Format calendar dates without UTC/local timezone conversion.
export function formatDashboardPeriodDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return '—';
  const date = new Date(`${value}T00:00:00Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) return '—';
  return value.split('-').reverse().join('/');
}

export function withDashboardPeriod(rows, fromDate, toDate) {
  return rows.map(row => ({ ...row, Period_Start: fromDate, Period_End: toDate }));
}
